import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7c0fa08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-template__container" }




export default /*#__PURE__*/_defineComponent({
  __name: 'PageTemplate',
  props: {
  hasBackground: {
    type: Boolean,
    required: false,
    default: false,
  },
  rightHeader: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["page-template", { 'u-bg-primary': props.hasBackground }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["page-header", { 'u-right-header': props.rightHeader }])
      }, [
        _renderSlot(_ctx.$slots, "header")
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["page-main-img", { 'left-content': props.rightHeader }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ], 2))
}
}

})